export default "__VITE_ASSET__ccec3641__"